import React from 'react';
// eslint-disable-next-line no-restricted-imports
import ThreadsCard, { Props } from 'plaid-threads/Card';

const Card: React.FC<Props> = (props) => {
  return <ThreadsCard {...props} />;
};

export default Card;
